import { Skeleton, Typography } from '@mui/material';
import { Box } from '@mui/system';

export default function ContractTitleSection({
  title,
  data,
  isLoading,
  ...rest
}) {
  return (
    <Box sx={{ flex: 1, ...rest }}>
      <Typography
        variant="subtitle2"
        color="text.secondary"
        sx={{ textTransform: 'uppercase', fontSize: '12px' }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 'bold',
          mb: 0.5,
          minHeight: '21px',
        }}
      >
        {isLoading && typeof data === 'string' ? (
          <Skeleton width="80%" />
        ) : (
          data
        )}
      </Typography>
    </Box>
  );
}
